import { useQuery } from "@tanstack/react-query";
import api from "../services/api";
import { CurrentUserDto, Permissions } from "../types/django/user";
import { authService } from "../services/authService";

const useCurrentUser = () => {
  // On vérifie s'il y a un token avant de lancer la requête
  const token = authService.getAccessToken();
  const hasToken = !!token;

  return useQuery<CurrentUserDto>({
    queryKey: ["current-user"],
    queryFn: async () => {
      const res = await api.get("/auth/me/");
      return res.data;
    },
    //  SÉCURITÉS LOGOUT :
    enabled: hasToken,
    retry: false,
  });
};
export const usePermission = () => {
  const { data: user, isLoading, error } = useCurrentUser();

  const token = authService.getAccessToken();
  const hasToken = !!token;
  
  const isReallyLoading = hasToken ? (isLoading || !user) && !error : false;

  const hasPermission = (permissionName: keyof Permissions): boolean => {
    if (!user) return false;
    const isAdmin = 
      user.role?.toLowerCase() === "admin" || 
      user.roles?.some(r => r.name?.toLowerCase() === 'admin');
      
    if (isAdmin) return true; 
    
   
    const permissionValue = user.permissions?.[permissionName];
  

    return !!permissionValue;
  };

  const hasAnyPermission = (permissionNames: (keyof Permissions)[]): boolean => {
    return permissionNames.some((perm) => hasPermission(perm));
  };

  return {
    hasPermission,
    hasAnyPermission,
    isLoading: isReallyLoading, 
    user,
  };
};